export default __webpack_public_path__ + "static/media/311.50cd9bec.gif";